import React, { useEffect, useState } from "react";
import "./style.css";

const UploadErrorSnackbar = ({ errors, onDismiss }) => {
  const [visibleErrors, setVisibleErrors] = useState([]);

  useEffect(() => {
    if (errors.length === 0) return;

    // Add new errors to visible list
    setVisibleErrors((prev) => {
      const existingIds = new Set(prev.map((e) => e.id));
      const newErrors = errors.filter((e) => !existingIds.has(e.id));
      return [...prev, ...newErrors];
    });
  }, [errors]);

  useEffect(() => {
    if (visibleErrors.length === 0) return;

    // Auto-dismiss after 5 seconds
    const timer = setTimeout(() => {
      setVisibleErrors((prev) => prev.slice(1));
      if (onDismiss) onDismiss();
    }, 5000);

    return () => clearTimeout(timer);
  }, [visibleErrors, onDismiss]);

  if (visibleErrors.length === 0) return null;

  return (
    <div className="upload-error-snackbar-container">
      {visibleErrors.map((error, index) => (
        <div
          key={error.id}
          className="upload-error-snackbar"
          style={{ animationDelay: `${index * 80}ms` }}
        >
          <button
            className="upload-error-snackbar-close"
            onClick={() => {
              setVisibleErrors((prev) => prev.filter((e) => e.id !== error.id));
              if (onDismiss) onDismiss();
            }}
            aria-label="סגור"
          >
            &times;
          </button>

          {error.thumbnail && (
            <div className="upload-error-snackbar-thumb">
              <img src={error.thumbnail} alt="" />
            </div>
          )}

          <div className="upload-error-snackbar-content">
            <span className="upload-error-snackbar-title">שגיאה בהעלאת תמונה</span>
            <span className="upload-error-snackbar-msg">
              {error.message || "הפורמט לא נתמך. נסו להעלות קובץ JPEG או PNG"}
            </span>
          </div>

          <div className="upload-error-snackbar-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" stroke="#c43d3d" strokeWidth="1.5" />
              <path d="M10 6v5" stroke="#c43d3d" strokeWidth="1.5" strokeLinecap="round" />
              <circle cx="10" cy="14" r="0.75" fill="#c43d3d" />
            </svg>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UploadErrorSnackbar;
